import { useState } from 'react';
import './datesCustomSup.css';
import ReactLoading from 'react-loading';
import errorHandle from '../../../utils/errorHandle';
import DeleteIcon from '../../../assets/icons/trvto_deleteIcon.svg';
import Dialog from '../../dialogModal/dialogModal';
import { toast } from 'react-toastify';
import { standardDate } from '../../../utils/formatDate';
import { unavailableDateFun } from '../../../api/supportAdmin';
import AddBooking from '../../../pages/supTripDateDetails/addBooking/AddBooking';

export default function DatesCustomSup({ datesType, data, refresh, packData }) {
    const [loading, setLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [addBo, setAddBo] = useState(false);
    const [dateToDelete, setDateToDelete] = useState('');
    const packId = window.location.pathname.split('/')[5];
    const sortedDates = data.sort((a, b) => new Date(a) - new Date(b));
    const deleteUnavailableDate = async () => {
        try {
            setLoading(true);
            const response = await unavailableDateFun({ packId, date: dateToDelete }, 'remove');
            if (response.status === 200) {
                setLoading(false);
                toast.success('Date deleted successfully');
                setDeleteModal(false);
                refresh();
            }
        } catch (err) {
            setLoading(false);
            errorHandle(err);
        }
    };

    return (
        <div>
            <div className='orgDateTabBtnDiv'>
                <button
                    className={'orgDateTabUpCo blueBtn'}
                    onClick={() => {
                        setAddBo(true);
                    }}
                >
                    Add Booking
                </button>
            </div>
            {loading ? (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            ) : (
                <table className='orgDatesTabTable'>
                    <thead className='orgDatesTabHead'>
                        <tr>
                            <th>Unavailable Date</th>
                            <th>Action</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedDates.map((row, rowKey) => {
                            return (
                                <tr key={rowKey} className='orgDatesTabRow'>
                                    <td>{standardDate(row.split('T')[0]) ?? 'N/A'}</td>
                                    <td>
                                        <button
                                            className='deleteBtn'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setDeleteModal(true);
                                                setDateToDelete(row);
                                            }}
                                        >
                                            <img src={DeleteIcon} alt='trvto_delete' />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
            {deleteModal && (
                <Dialog openModal={deleteModal} heading={'Delete Confirmation!'}>
                    <div className='dialogContent'>
                        <p className='confirmationText'>Are you sure?</p>
                        <p className='confirmationMessage'>You want to delete this Date.</p>
                        <div className='alignCenter'>
                            <button className='dialogActBtn submit' onClick={deleteUnavailableDate}>
                                Yes
                            </button>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
            {addBo && (
                <AddBooking
                    packData={packData}
                    setAddBo={setAddBo}
                    setLoading={setLoading}
                    refresh={refresh}
                    dates={data}
                />
            )}
        </div>
    );
}
